'use strict';

angular.module('study.error', [
    'error',
    'ui.router',
]);
